import { useQuery } from '@tanstack/react-query'

import { api } from '@/lib/api/client'

export type FreshnessState = 'FRESH' | 'AGING' | 'STALE' | 'NO_DATA'

/**
 * How old the tenant's DPD data is. Tenant-wide — it describes the feed, not
 * any one case — so every screen shows the same answer.
 */
export interface Freshness {
  tier: 'GRAVITON' | 'EXCEL' | null
  /** Newest instant any DPD reading is as of. Null before the first upload/event. */
  asOfAt: string | null
  state: FreshnessState
  agingHours: number
  staleHours: number
}

export function useFreshness() {
  return useQuery({
    queryKey: ['freshness'],
    queryFn: async () => {
      const res = await api.get<Freshness>('/v1/freshness')
      return res.data
    },
    // The state moves with the clock, not only with new data.
    refetchInterval: 5 * 60_000,
  })
}
